import { connect } from 'react-redux';
import {
    getAppLocale,
    getCurrencyFormat,
    getIsAppRebrandActive,
} from '../../selectors/app';
import {
    getEventEndDate,
    getEventImageSrc,
    getEventStartDate,
    getEventTitle,
} from '../../selectors/event';
import {
    getEventInfoCardTimezone,
    isSeriesInfiniteCalendar,
} from '../../selectors/infiniteCalendarSeries/infiniteCalendarSeries';
import { getCurrencyFromOrder } from '../../selectors/order/typedOrderSelectors';
import { getDisplayCostProps } from '../../selectors/tickets/getDisplayCostProps';
import { CheckoutState } from '../../state';
import { normalizeLocale } from '../../utils/general';
import { DATE_FORMATS } from '../InfiniteCalendarSeries/constants';
import { getFormattedDate } from '../InfiniteCalendarSeries/utils';
import EventInfoCard from './EventInfoCard';

export const mapStateToProps = (state: CheckoutState) => {
    const isSeriesInfiniteCalendarViewActive = isSeriesInfiniteCalendar(state);
    const currency = getCurrencyFromOrder(state);
    const { totalCostUnformatted } = getDisplayCostProps(state);
    const locale = normalizeLocale(getAppLocale(state));
    const timezone = getEventInfoCardTimezone(
        state,
        !isSeriesInfiniteCalendarViewActive,
    );

    // Check if start/end dates should be hidden
    const hideStartDate = state.event.hideStartDate;
    const hideEndDate = state.event.hideEndDate;
    const startDate = getEventStartDate(state);
    const endDate = getEventEndDate(state);

    // Use getFormattedDate with hide flags
    const eventDate = getFormattedDate({
        isoDate: startDate.utc,
        timezone,
        hideStartDate,
        hideEndDate,
        endIsoDate: endDate?.utc,
    }).format(locale, DATE_FORMATS.SHORT_DATE_WITH_TIME);

    return {
        eventTitle: getEventTitle(state),
        eventImageSrc: getEventImageSrc(state),
        eventDate,
        currency,
        totalCostUnformatted,
        currencyFormat: getCurrencyFormat(state) || '',
        isAppRebrandActive: getIsAppRebrandActive(state),
    };
};

export const ConnectedEventInfoCard = connect(mapStateToProps)(EventInfoCard);

export default ConnectedEventInfoCard;
